import * as React from 'react';
export const IcDisposeOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.894 6.55a1 1 0 00-1.78 0 5.719 5.719 0 01-1.24 1.6 14.55 14.55 0 00-2-5.7 1 1 0 00-1.16-.45 1 1 0 00-.71 1 3.82 3.82 0 01-1.26 2.5l10.06 10.06c.55-3.2-.75-6.7-1.91-9.01zm2.82 12.74l-16-16a1.004 1.004 0 00-1.42 1.42L6.634 8a8 8 0 001.62 13 3.13 3.13 0 01.88-2.9c1-1.08 1.87-2 1.87-2.73a.5.5 0 01.73-.37 4.64 4.64 0 012.14 2.52c1.05-2.13 2.34 2.19 2 3.45a9 9 0 002.13-1.61l1.34 1.35a.999.999 0 001.42 0 1 1 0 00-.05-1.42z'
      fill='currentColor'
    />
  </svg>
);
